import router from '@/router';
import Auth from '@/services/Auth';
import Brand from '@/services/Brand';
import User from '@/services/User';

router.beforeEach(async (to, from, next) => {
	if (window.isLoggedIn) {
		// Brand Check
		if (Brand.getBrand() === 'insurecareteams') {
			return next();
		}

		if (
			Auth.checkPermission('STAFF') ||
			Auth.checkPermission('STAFF_ACCOUNTING') ||
			Auth.checkPermission('STAFF_CLAIMS') ||
			Auth.checkPermission('STAFF_SUPER')
		) {
			return next();
		}

		if (Auth.checkPermission('ACCOUNT_ADMIN')) {
			return next();
		}

		const userPermissions = Auth.permissionsList();
		const RiskMngCheck =
			userPermissions.length > 0
				? userPermissions.every(item =>
						[
							'VIEW_RISK_MANAGEMENT',
							'VIEW_CME',
							'VIEW_CYBER_SOLUTIONS',
							'VIEW_LATEST_NEWS',
						].includes(item),
				  )
				: false;

		if (RiskMngCheck) {
			return next();
		}

		// Post Registration check
		switch (to.name) {
			case 'verifyphone':
			case 'signout':
			case 'registration':
				return next();

			default: {
				const isRegistered: boolean = await User.checkRegistered();
				if (!isRegistered) {
					return next('/registration');
				}
				break;
			}
		}

		return next();
	} else {
		return next();
	}
});
